<template>
  <b-modal
      ref="modalRef"
      size="xl"
      centered
      hide-footer
      scrollable
      :title="modalTitle"
      @hidden="onHidden"
  >
    <b-table
        :items="items"
        :fields="fields"
        responsive
        show-empty
        :empty-text="$t('No matching records found')"
        :busy="isBusy"
        class="mt-1"
    >
      <template #table-busy>
        <div class="text-center text-primary my-2">
          <b-spinner class="align-middle"/>
          <strong class="ml-1">{{ $t('Loading') }}...</strong>
        </div>
      </template>

      <template #cell(action)="data">
        <div class="d-flex flex-wrap">
          <b-badge
              v-for="(field, index) in formatActionItems(data.value)"
              :key="index"
              variant="light-primary"
              class="mr-50 mb-50"
          >
            {{ field }}
          </b-badge>
        </div>
      </template>

      <template #cell(changedByName)="data">
        <b-link
            v-if="data.item.changedBy"
            :to="{ name: 'register-user', params: { id: data.item.changedBy } }"
            class="font-weight-bold text-primary"
        >
          {{ data.value }}
        </b-link>
        <span v-else>{{ data.value }}</span>
      </template>
    </b-table>

    <div class="mx-2 mb-2">
      <b-row>
        <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start">
          <span class="text-muted">
            {{ $t('Showing') }} {{ dataMeta.from }} {{ $t('to') }} {{ dataMeta.to }}
            {{ $t('of') }} {{ dataMeta.of }} {{ $t('entries') }}
          </span>
        </b-col>
        <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">
          <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
              @change="onPageChange"
          >
            <template #prev-text>
              <feather-icon icon="ChevronLeftIcon" size="18"/>
            </template>
            <template #next-text>
              <feather-icon icon="ChevronRightIcon" size="18"/>
            </template>
          </b-pagination>
        </b-col>
      </b-row>
    </div>
  </b-modal>
</template>

<script>
import {
  BModal,
  BTable,
  BSpinner,
  BBadge,
  BLink,
  BRow,
  BCol,
  BPagination,
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import useUserHistory from '../useUserHistory'

export default {
  components: {
    BModal,
    BTable,
    BSpinner,
    BBadge,
    BLink,
    BRow,
    BCol,
    BPagination,
  },
  setup(_, { root }) {
    const modalRef = ref(null)

    const {
      items,
      isBusy,
      currentPage,
      perPage,
      totalRows,
      dataMeta,
      modalTitle,
      fields,
      fetchHistory,
      openForUser,
      reset,
    } = useUserHistory()

    const formatActionItems = value => {
      if (!value) return []
      return String(value).split(';').map(item => item.trim()).filter(Boolean)
    }

    const onPageChange = page => {
      fetchHistory(page).catch(() => {
        root.$swal(root.$t('Error'), root.$t('An error occurred while trying to load data'), 'error')
      })
    }

    const onHidden = () => reset()

    const open = user => {
      openForUser(user)
          .then(() => {
            modalRef.value.show()
          })
          .catch(() => {
            root.$swal(root.$t('Error'), root.$t('An error occurred while trying to load data'), 'error')
          })
    }

    return {
      modalRef,
      items,
      isBusy,
      currentPage,
      perPage,
      totalRows,
      dataMeta,
      modalTitle,
      fields,
      formatActionItems,
      onPageChange,
      onHidden,
      open,
    }
  },
}
</script>
